import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadResolver from "components/LoadResolver";
import { useTranslation } from "react-i18next";
import UserManagementTable from "../UserManagementTable/UserManagementTable";
import UserGroupEdition from "../UserGroupEdition/UserGroupEdition";

const UserManagementEditor = () => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const [isUserEditing, setIsUserEditing] = useState(false);
  const [user, setUser] = useState("");
  const isUserLoading = useSelector((state) => state.users.isLoading);
  const isGroupsLoading = useSelector((state) => state.userGroups.isLoading);
  const handleEditUserClick = (user) => {
    setIsUserEditing(true);
    setUser(user);
  };

  useEffect(() => {
    dispatch.users.init();
    dispatch.userGroups.init();
  }, []);

  return (
    <LoadResolver isLoading={isUserLoading || isGroupsLoading}>
      <div className="page-container">
        <h2>{t("user_management")}</h2>
        {isUserEditing && <UserGroupEdition user={user} setIsUserEditing={setIsUserEditing} />}
        <UserManagementTable
          handleEditUserClick={handleEditUserClick}
          isUserEditing={isUserEditing}
        />
      </div>
    </LoadResolver>
  );
};

export default UserManagementEditor;
